exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-manager-main-container .preferencesBtn{position:fixed;z-index:99999999}.cookie-manager-main-container .preferencesBtn .btn{height:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/sass-loader/lib/loader.js!./src-cookie-manager/views/preferences-button/style.scss
// module id = 411
// module chunks = 0